import axios from 'axios'
import config from '@/config';
import { installSessionExpiry } from './sessionExpiry';

const protectedApi = axios.create({
  baseURL: config.apiBaseUrl + 'api',
  timeout: 25000,
})

protectedApi.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem('accessToken')

    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`
    }

    return config
  }
)

installSessionExpiry(protectedApi);

export { protectedApi }
